import { createPutAsyncSlice } from '@sonar-software/xuder';
import { putCurrentUserProfilePicture } from '../../../../api';

export const coreUsersCurrentPicturePutAsyncSlice = createPutAsyncSlice({
	name: 'CoreUsersCurrentPicture',
	receive: false,
	request: true,
	requestHandler: putCurrentUserProfilePicture
});
